import { useTranslate } from '@tolgee/react';
import { Popover } from 'antd';
import type { CitationKnowledgeScope } from 'services/api/supplementKnowledge';

/** 引用接口只返回范围标识；只读展示，不挂接会立即持久化的范围编辑器。 */
export default function CitationScope({ scope }: { scope?: CitationKnowledgeScope }) {
  const { t } = useTranslate();
  if (!scope) return <span>—</span>;
  return (
    <Popover
      content={
        <div className="max-h-64 max-w-lg overflow-auto">
          {scope.spus.map((spu) => (
            <div key={spu.spuKey} className="mb-2 break-all">
              <div>{spu.spuKey}</div>
              <div>SKU: {spu.coverAllSkus ? t('全部') : spu.selectedSkuKeys.join(', ') || '—'}</div>
            </div>
          ))}
        </div>
      }
    >
      <span>{t('single_x_spu', { x: scope.spus.length })}</span>
    </Popover>
  );
}
